import { RefereeLicenseForm } from '../create/components/referee-license-form';
import { Schema } from '../create/components/referee-license-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { idParamSchema, licenseIdParamSchema } from '~/schemas';
import { useUpdateRefereeLicenseMutation } from '../mutations';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useRefereeLicenseQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';

export const Page = withPrivateRoute(() => {
  const mutation = useUpdateRefereeLicenseMutation();
  const navigate = useNavigate();

  const { licenseId } = useParams(licenseIdParamSchema.parse);
  const { id } = useParams(idParamSchema.parse);
  const { data } = useRefereeLicenseQuery(licenseId);

  async function onSubmit(data: Schema) {
    await mutation.mutateAsync({ id: licenseId, judge: id, ...data });
    navigate(`/referees/${id}/licenses`);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera licens" />

      <PageLayout.Section>
        <RefereeLicenseForm
          defaultValues={{
            ...data,
            club: [data.club.name, data.club.id],
            start_date: data.start_date,
            end_date: data.end_date,
          }}
          onSubmit={onSubmit}
          isLoading={false}
          mode="edit"
        />
      </PageLayout.Section>
    </Fragment>
  );
});
